module.exports = __webpack_public_path__ + "um.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/um.svg
// module id = 866
// module chunks = 0